export default function Features() {
  return <h2>Features Page</h2>;
}
